import React from 'react';
import Styled from './RadioControl.style';
import { Radio } from '../index';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
interface RadioControlProps {
  answerKey: string;
  options: Array<any>;
  key: string;
  updateAnswerKey: Function;
  value: string;
  text: string;
  title: string;
  style?: React.CSSProperties;
}

const RadioControl: React.FC<RadioControlProps> = (props) => {
  const { title, style, answerKey, updateAnswerKey = () => void 0 } = props;
  const { t } = useTranslation('common');
  const handleAnswer = (value) => {
    updateAnswerKey(answerKey, value);
  };

  const renderOptions = props.options.map((option, index) => {
    return (
      <Styled.Row key={index}>
        <Radio
          id={answerKey + '--' + option.value}
          name={answerKey + '--' + option.value}
          onChange={() => handleAnswer(option.value)}
          aria-label={option.value}
          title={i18next.t(option.text)}
          checked={props.value === option.value}
          value={option.value}
        />
      </Styled.Row>
    );
  });

  return (
    <Styled.Wraper style={style} role="group" aria-labelledby="my-radio-group">
      <p style={{ margin: 0, padding: 0 }}>{t(title)}</p>
      <div style={{ display: 'flex' }}>{renderOptions}</div>
    </Styled.Wraper>
  );
};
export default RadioControl;
